import type { Bulle } from '../partage/api/types';
import { estComplete } from './saisieTapee';
import { DATE_PRECISE, TROIS_JOURS, TROIS_SEMAINES, DIX_JOURS } from '../partage/vocabulaire';

/**
 * Les délais rapides de la fiche au téléphone (ticket 08 du chantier telephone) :
 * au retour de la banque, on pose en un
 * toucher ce qu'on vient d'entendre, « réponse sous 10 jours ».
 *
 * Un délai rapide pose **des jours**, jamais des mois : trois semaines valent 21 jours, parce
 * que c'est ce qu'on t'a dit au guichet, pas un texte de loi qui compterait de quantième à
 * quantième (ce délai-là, en mois, se pose dans « Quand », ligne « Le monde met »). Il efface
 * donc un délai en mois : les deux unités ne coexistent jamais (SPEC §3).
 *
 * « Une date précise » ne pose rien d'elle-même : elle ouvre le champ de date.
 */
export type DelaiRapide =
  | { sorte: 'jours'; mot: string; jours: number }
  | { sorte: 'date'; mot: string };

export const DELAIS_RAPIDES: readonly DelaiRapide[] = [
  { sorte: 'jours', mot: TROIS_JOURS, jours: 3 },
  { sorte: 'jours', mot: DIX_JOURS, jours: 10 },
  { sorte: 'jours', mot: TROIS_SEMAINES, jours: 21 },
  { sorte: 'date', mot: DATE_PRECISE },
];

/**
 * Ce qu'un délai rapide en jours demande : ces jours-là. Le délai en mois s'efface par la règle
 * de `commun/` (`autreDelaiEfface`), au serveur et dans la mise à jour optimiste.
 */
export function champsDuDelai(jours: number): Pick<Bulle, 'delaiJours'> {
  return { delaiJours: jours };
}

/**
 * Ce qu'une date précise écrit : l'échéance, le champ de date de « Quand ». Un champ vidé ne
 * pose rien (on garde ce qui y était), plutôt qu'effacer une échéance d'un toucher raté ; une
 * date qui n'existe pas, ou d'une année hors de 1900 à 2199, non plus (`estComplete`).
 */
export function champsDeLaDate(jour: string): Pick<Bulle, 'dateEcheance'> | null {
  return jour !== '' && estComplete('jour', jour) ? { dateEcheance: jour } : null;
}
